import { render, staticRenderFns } from "./Housing.vue?vue&type=template&id=27f1c816&scoped=true"
import script from "./Housing.vue?vue&type=script&lang=js"
export * from "./Housing.vue?vue&type=script&lang=js"
import style0 from "./Housing.vue?vue&type=style&index=0&id=27f1c816&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f1c816",
  null
  
)

export default component.exports